module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "invite-records"
    }
  }, [_c('div', {
    staticClass: "header clearfix"
  }, [_c('div', {
    staticClass: "little-title"
  }, [_c('span', {
    class: {
      active: _vm.isRewardTab
    },
    on: {
      "click": function($event) {
        _vm.isRewardTab = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('rewardDate')))]), _vm._v(" "), _c('span', {
    class: {
      active: !_vm.isRewardTab
    },
    on: {
      "click": function($event) {
        _vm.isRewardTab = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('friends')))]), _vm._v(" "), (_vm.isRewardTab) ? _c('router-link', {
    attrs: {
      "to": "/reward-rules"
    }
  }, [_vm._v(_vm._s(_vm.$t('rules')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "records-component"
  }, [_c('reward-records-pc', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isRewardTab),
      expression: "isRewardTab"
    }],
    staticClass: "pc-show",
    attrs: {
      "init-award-records-data": _vm.initAwardRecordsData
    }
  }), _vm._v(" "), _c('reward-records-m', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isRewardTab),
      expression: "isRewardTab"
    }],
    staticClass: "phone-show",
    attrs: {
      "init-award-records-data": _vm.initAwardRecordsData
    }
  }), _vm._v(" "), _c('friend-records-pc', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isRewardTab),
      expression: "!isRewardTab"
    }],
    staticClass: "pc-show",
    attrs: {
      "init-invitation-records-data": _vm.initInvitationRecordsData
    }
  }), _vm._v(" "), _c('friend-records-m', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isRewardTab),
      expression: "!isRewardTab"
    }],
    staticClass: "phone-show",
    attrs: {
      "init-invitation-records-data": _vm.initInvitationRecordsData
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4756ad6e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/affiliate/inviteRecord/InviteRecord.vue
// module id = 1314
// module chunks = 1